export default "/_next/static/sounds/countdown_trim-baa2592ae2828c6c3505b15e96cd3091.mp3";